export const ROOT_INVITES_COLLECTION = "collaborators_invites";
export const ROOT_USERDATA_COLLECTION = "userdata";
